var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.40625C4.38867 1.40625 2.92773 2.26562 2.11133 3.64062C1.31641 5.03711 1.31641 6.73438 2.11133 8.10938C2.92773 9.50586 4.38867 10.3438 6 10.3438C7.58984 10.3438 9.05078 9.50586 9.86719 8.10938C10.6621 6.73438 10.6621 5.03711 9.86719 3.64062C9.05078 2.26562 7.58984 1.40625 6 1.40625ZM6 11.375C4.02344 11.375 2.21875 10.3438 1.23047 8.625C0.242188 6.92773 0.242188 4.84375 1.23047 3.125C2.21875 1.42773 4.02344 0.375 6 0.375C7.95508 0.375 9.75977 1.42773 10.748 3.125C11.7363 4.84375 11.7363 6.92773 10.748 8.625C9.75977 10.3438 7.95508 11.375 6 11.375ZM5.48438 8.28125V7.76562V6.39062H4.10938H3.59375V5.35938H4.10938H5.48438V3.98438V3.46875H6.51562V3.98438V5.35938H7.89062H8.40625V6.39062H7.89062H6.51562V7.76562V8.28125H5.48438Z",
    fill: "#9DD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.4c6b62e5103a60e33701a798543e3756.svg";
export { ForwardRef as ReactComponent };